export default __webpack_public_path__ + "static/media/event.e34a2aed.svg";